import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import App from './App';
import AppProvider from './store';

import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundaryProvider from './components/UtilComponents/error-boundary/';

import * as Sentry from '@sentry/react';
// import { ErrorBoundary } from '@sentry/react';

import { QueryClientProvider, QueryClient } from 'react-query';

import { ReactQueryDevtools } from 'react-query/devtools';

import { PostHogProvider } from 'posthog-js/react';
// import { useEffect } from 'react';

// Type declaration for module.hot (HMR)
declare let module: {
	hot?: {
		accept: (path: string, callback: () => void) => void;
	};
};
if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://77ddfe3be518d58efe8d3701360b1dec@o4509983381782528.ingest.de.sentry.io/4510062932394064',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.browserProfilingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
	onRecoverableError: Sentry.reactErrorHandler(),
});

const AppContent = () => (
	<React.StrictMode>
		<PostHogProvider
			apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string}
			options={{
				api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
				defaults: '2025-05-24',
				capture_exceptions: true,
				debug: process.env.NODE_ENV === 'development',
			}}
		>
			<ErrorBoundaryProvider>
				<QueryClientProvider client={queryClient}>
					<AppProvider>
						<Router>
							<App />
						</Router>
					</AppProvider>
					{/* <ReactQueryDevtools initialIsOpen={false} /> */}
				</QueryClientProvider>
			</ErrorBoundaryProvider>
		</PostHogProvider>
	</React.StrictMode>
);

root.render(<AppContent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Enable Hot Module Replacement for development
if (module.hot && process.env.NODE_ENV === 'development') {
	module.hot.accept('./App', () => {
		root.render(<AppContent />);
	});
}
